/** Org members are org-scoped (`GET /orgs/{org}/members`). */
export const orgMembersKeys = {
  list: (organizationId: string) =>
    ["resources", organizationId, "org-members", "list"] as const,
};
